import { Stack, Typography, Box } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { text, black, background } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { spacing } from "@/theme/variables";
import { OverviewDetails } from "@/features/mock-exam/components/mock-exam/OverviewDetails";
import { TakeExamButton } from "@/features/mock-exam/components/mock-exam/TakeExamButton";
import { OverviewNoQuestionContainer } from "@/features/mock-exam/components/mock-exam/OverviewNoQuestionContainer";

type OverviewSectionProps = {
  metadata: {
    totalQuestions: number;
    timeLimitMinutes: number;
    passingScorePercentage: number;
    passingQuestionCount: number;
  };
  onStartMockExam: () => void;
};

/**
 * MockExam overview section with details and start button.
 */
export const OverviewSection: FC<OverviewSectionProps> = ({ metadata, onStartMockExam }) => {
  const { t } = useTranslation();
  const hasQuestions = metadata.totalQuestions > 0;

  return (
    <Box
      display="flex"
      flexDirection="column"
      p={spacing.sm}
      gap={spacing.sm}
      bgcolor={background.white}
      borderBottom={`1px solid ${black[95]}`}
    >
      {/* Title */}
      <Stack minHeight={36} gap={spacing.xs} pb={spacing.smd} borderBottom={`1px solid ${black[95]}`}>
        <Typography sx={{ ...typography.sub16Bold, color: text.primary }}>{t("mockExam.title")}</Typography>
      </Stack>

      {hasQuestions ? (
        <>
          <OverviewDetails metadata={metadata} />
          <TakeExamButton onClick={onStartMockExam} />
        </>
      ) : (
        <OverviewNoQuestionContainer />
      )}
    </Box>
  );
};
